export const PERMISSION_COLUMNS = [
  { key: 'view', label: '查看／搜尋' },
  { key: 'edit', label: '新增／修改' },
  { key: 'delete', label: '刪除／退庫' },
  { key: 'approve', label: '審核／特殊' },
];

export const PERMISSION_GROUPS = [
  {
    id: 'basic',
    title: '基本資料',
    rows: [
      { label: 'BOM', permissions: { view: 'bom3', edit: 'bom1', delete: 'bom2' } },
      { label: '工程名稱', permissions: { view: 'engineering3', edit: 'engineering1', delete: 'engineering2' } },
      { label: '材料係數', permissions: { view: 'materialParam3', edit: 'materialParam1', delete: 'materialParam2' } },
      { label: '料品資料', permissions: { edit: 'itemSet1', delete: 'itemSet2' } },
      { label: '機台設定', permissions: { view: 'machineSet3', edit: 'machineSet1', delete: 'machineSet2' } },
      { label: '職場設定', permissions: { view: 'workPlace3', edit: 'workPlace1', delete: 'workPlace2' } },
      { label: '廠商資料', permissions: { view: 'manufacturer3', edit: 'manufacturer1', delete: 'manufacturer2' } },
      { label: '售價一覽表', permissions: { view: 'sellPrice3', edit: 'sellPrice1', delete: 'sellPrice2' } },
      { label: '進價一覽表', permissions: { view: 'purchasePrice3', edit: 'purchasePrice1', delete: 'purchasePrice2' } },
    ],
  },
  {
    id: 'business',
    title: '業務／訂單／出貨',
    rows: [
      { label: '訂單手輸', permissions: { edit: 'orderByHand1' } },
      { label: '訂單輸入', permissions: { edit: 'orderByExcel1' } },
      { label: '出貨交運單表頭', permissions: { view: 'shipOrderTop3', edit: 'shipOrderTop1' } },
      { label: '出貨交運單明細', permissions: { view: 'shipDetail3', edit: 'shipOrderBottom1' } },
      { label: '台日檢收票', permissions: { view: 'taiCheckBill3', edit: 'taiCheckBill1' } },
      { label: '發票總覽', permissions: { view: 'billTotalView3' } },
    ],
  },
  {
    id: 'purchase',
    title: '採購／請購／入庫',
    rows: [
      { label: '列印請採購', permissions: { view: 'printBuy3' } },
      { label: '請採購單', permissions: { view: 'purchaseBill3', edit: 'purchaseBill1', approve: 'purchaseSignIn4' }, specialLabel: '簽核' },
      { label: '請採購預定入庫', permissions: { view: 'purchaseWillInStock3' } },
      { label: '採購入庫作業', permissions: { view: 'purchaseInStockWork3', edit: 'purchaseInStockWork1', delete: 'purchaseInStockWork2' }, deleteLabel: '退庫' },
      { label: '採購入庫明細表', permissions: { view: 'purchaseInStockDetail3', delete: 'purchaseInStockDetail2' } },
      { label: '採購入庫統計表', permissions: { view: 'purchaseInStockStatistics3', delete: 'purchaseInStockStatistics2' } },
      { label: '驗收入庫明細', permissions: { view: 'checkStockInDetail3' } },
      { label: '未簽核查詢', permissions: { view: 'signSelect3' } },
    ],
  },
  {
    id: 'production',
    title: '生產／資材卡',
    rows: [
      { label: '生管資材卡', permissions: { view: 'matCard3', delete: 'matCard2' } },
      { label: '生管資材卡明細表', permissions: { view: 'matCardDetail3' } },
      { label: '生管資材卡統計表', permissions: { view: 'matCardStatistics3', delete: 'matCardStatistics2' } },
      { label: '發動生產', permissions: { edit: 'launchProduction1' } },
      { label: '成品報工（測試版）', permissions: { view: 'productionReportView', edit: 'productionReportCreate', delete: 'productionReportDelete', approve: 'productionReportUpdate' }, specialLabel: '修改', deleteLabel: '作廢' },
      { label: '補印製令', permissions: { delete: 'makeCmd2' } },
    ],
  },
  {
    id: 'inventory',
    title: '庫存管理',
    rows: [
      { label: '庫存異動調整', permissions: { view: 'stockChange3', edit: 'stockChange1', approve: 'stockChange4' }, specialLabel: '審核' },
    ],
  },
  {
    id: 'accounting',
    title: '應收／應付帳款',
    rows: [
      { label: '應付帳款', permissions: { view: 'shouldPay3', edit: 'shouldPay1', delete: 'shouldPay2' } },
      { label: '應收帳款', permissions: { view: 'shouldGet3', edit: 'shouldGet1' } },
      { label: '應收帳款總表', permissions: { view: 'shouldGetTotal3', edit: 'shouldGetTotal1' } },
      { label: '應收對帳單表頭', permissions: { edit: 'shouldGetBillTop1' } },
      { label: '應收對帳單明細', permissions: { view: 'shouldGetBillBottom3', edit: 'shouldGetBillBottom1', delete: 'shouldGetBillBottom2' } },
    ],
  },
  {
    id: 'system',
    title: '系統管理',
    rows: [
      { label: '簽核查詢', permissions: { view: 'signInSelect3' } },
      { label: '全局審核／解鎖', permissions: { approve: 'approval' }, specialLabel: '審核權' },
      { label: '使用者帳號管理', permissions: { approve: 'canCruduser' }, specialLabel: '帳號管理' },
    ],
  },
];
